<template>
  <div>
    <b-overlay :show="apiLoading" rounded="sm" spinner-variant="primary">
      <div class="container my-2">
        <p class="my-2">
          Enter A Banknote's <u>Authentication Number</u> Below To Verify Authenticity And Banknote Ownership in BNW
          Database
        </p>
        <p class="my-1">Authentication #:</p>
        <div class="d-flex my-4 align-items-baseline" v-for="(input, index) in checkInputs" :key="index">
          <b-input class="check-input mr-2" :key="input.id" v-model="input.value" />
          <b-button class="btn btn-primary check-button" @click="checkAuth(input, index)">Check Item</b-button>
          <trash-2-icon
            role="button"
            v-if="checkInputs.length > 1"
            @click="deleteNote(index)"
            class="icon text-danger align-self-center ml-3 cursor-pointer"
          ></trash-2-icon>
          <!--                    <b-card v-if="input.object" :img-src="input.object?.product.media[0]?.original_url" img-top>-->
          <!--                        <b-card-text class="text-center">-->
          <!--                            {{input.object.owner.user.first_name}} {{input.object.owner.user.last_name}}-->
          <!--                        </b-card-text>-->
          <!--                    </b-card>-->
        </div>
        <b-button class="my-2 btn btn-primary" @click="addNewNote">Add Another Note</b-button>
      </div>
      <div v-if="showForm" class="owner-info">
        <div class="container">
          <div class="d-flex">
            <div class="d-flex flex-column mr-4 w-50">
              <p class="my-1">New Owner Data:</p>
              <b-input
                required
                v-model="newOwnerName"
                placeholder="New Owner Name*"
                class="my-2 black-placeholder"
              ></b-input>
              <b-input
                required
                v-model="newOwnerEmail"
                placeholder="New Owner Email*"
                class="my-2 black-placeholder"
              ></b-input>
            </div>
            <div class="d-flex flex-column w-50">
              <p class="my-1">Owner Note:</p>
              <b-textarea class="my-2" v-model="ownerNote"></b-textarea>
            </div>
          </div>
          <h3 class="mt-2">Files</h3>
          <p>You Can Upload To 20 MB At Once Allowed File Formats: PNG, JPG, GIF, PDF</p>
          <input type="file" class="my-1" placeholder="Upload File" @change="uploadFile" />
        </div>
      </div>
      <div v-if="showForm" class="container">
        <b-form-checkbox v-model="termsAccepted" class="my-4"
          >I have read and accepted the Terms & Conditions
        </b-form-checkbox>
        <b-button class="btn btn-primary my-4" :disabled="apiLoading" @click="submitAction">Submit Request </b-button>
      </div>
    </b-overlay>
  </div>
</template>

<script>
import { Trash2Icon } from "vue-feather-icons"

export default {
  components: { Trash2Icon },
  data() {
    return {
      checkInputs: [
        {
          id: this.generateUniqueId(),
          cssClass: "check-input",
          value: "",
          acceptedValue: null
        }
      ],
      newOwnerName: null,
      newOwnerEmail: null,
      ownerNote: "",
      fileId: null,
      termsAccepted: false,
      apiLoading: false
    }
  },
  props: ["auth_number"],
  computed: {
    showForm() {
      let show = false
      this.checkInputs.forEach(item => {
        if (item.acceptedValue) {
          show = true
        }
      })
      return show
    }
  },
  methods: {
    deleteNote(index) {
      this.checkInputs.splice(index, 1)
    },
    addNewNote() {
      // Generate a unique ID for the new component (you can use a library like uuid)
      const newComponentId = this.generateUniqueId()
      const newComponent = {
        id: newComponentId,
        cssClass: "check-input",
        value: "",
        acceptedValue: null
      }

      // Push the new component to the components array
      this.checkInputs.push(newComponent)
    },
    generateUniqueId() {
      return Math.random().toString(36).substr(2, 9)
    },
    checkAuth(input, index) {
      if (!input.value) return
      this.apiLoading = true
      $.ajax({
        method: "GET",
        url: "/transfer_ownership/auth",
        data: { auth_number: input.value }
      })
        .then(res => {
          if (res.status_code != 200) {
            this.$errorNotify(res.message)
          } else if (!res.data) {
            this.$errorNotify("Authentication Number doesn't exist")
            this.checkInputs[index].acceptedValue = null
          } else {
            this.checkInputs[index].acceptedValue = res.data
          }
        })
        .catch(xhr => {
          console.log(xhr)
          this.$errorNotify(xhr.responseJSON.message)
          this.checkInputs[index].acceptedValue = null
        })
        .always(() => {
          this.apiLoading = false
        })
    },
    uploadFile(event) {
      this.apiLoading = true
      const file = event.target.files[0]
      const fileName = file.name
      const fileExtension = fileName.split(".").pop().toLowerCase()

      // Check the file extension
      if (fileExtension != "jpg" && fileExtension != "png" && fileExtension != "gif" && fileExtension != "pdf") {
        // File format is valid
        this.$errorNotify("Invalid file format!")
        this.apiLoading = false
        return
      }
      const formData = new FormData()
      formData.append("files[]", file)
      //upload file through api and get the id of the media
      $.ajax({
        method: "POST",
        url: "/api/upload-media/?collection=transferOwnership_main_image",
        data: formData,
        processData: false,
        contentType: false
      })
        .then(res => {
          if (res.status_code != 200) {
            this.$errorNotify(res.message)
          } else {
            this.fileId = res.data[0]?.media[0].id
          }
        })
        .catch(xhr => {
          this.apiLoading = false
          console.log(xhr)
          this.$errorNotify(xhr.responseJSON.message)
        })
        .always(() => {
          this.apiLoading = false
        })
    },
    submitAction() {
      this.apiLoading = true
      if (this.checkInputs.length < 1 || !this.newOwnerName || !this.newOwnerEmail) {
        this.$errorNotify("Required data is missing!")
        this.apiLoading = false
        return
      }
      if (!this.fileId) {
        this.$errorNotify("Please add file!")
        this.apiLoading = false
        return
      }
      if (!this.termsAccepted) {
        this.$errorNotify("Please accept the terms!")
        this.apiLoading = false
        return
      }
      const formData = new FormData()
      formData.append("new_owner_name", this.newOwnerName)
      formData.append("new_owner_email", this.newOwnerEmail)
      formData.append("owner_note", this.ownerNote ? this.ownerNote : "")
      formData.append("files[]", this.fileId)
      let allValid = true
      this.checkInputs.forEach((element, index) => {
        if (!element.acceptedValue) {
          this.$errorNotify("100T+ checking is required")
          allValid = false
        }
        formData.append(`tap_banknote_ids[]`, "" + element.acceptedValue)
      })

      if (!allValid) {
        this.apiLoading = false
        return
      }
      $.ajax({
        method: "POST",
        url: "/transfer_ownership",
        data: formData,
        processData: false,
        contentType: false
      })
        .then(res => {
          if (res.status_code != 200) {
            this.$errorNotify(res.message)
          } else {
            this.clearForm()
            this.$successNotify("Submitted Successfully")
          }
        })
        .catch(xhr => {
          this.$errorNotify(xhr.responseJSON.message)
        })
        .always(() => {
          this.apiLoading = false
        })
    },
    clearForm() {
      this.newOwnerEmail = null
      this.ownerNote = null
      this.newOwnerName = null
      this.fileId = null
      this.termsAccepted = false
      this.checkInputs = [
        {
          id: this.generateUniqueId(),
          cssClass: "check-input",
          value: "",
          acceptedValue: null
        }
      ]
    }
  },
  mounted() {
    if (this.auth_number) {
      this.checkInputs[0].value = this.auth_number
      this.checkAuth(this.checkInputs[0])
    }
  }
}
</script>
<style lang="scss" scoped>
@import "../../../sass/utils/_variables";

.check-input {
  width: 45%;
}

.btn-primary {
  color: white;
  font-weight: bold;
}

u {
  color: $color-default;
}

input,
textarea {
  border: solid 1.5px #c2c2c2 !important;
}

.owner-info {
  background: #b7b7b72b;
  padding-top: 2rem;
  padding-bottom: 2rem;
  margin-top: 1rem;
}

.owner-info input,
.owner-info textarea {
  background: transparent;
  color: black !important;
}

.black-placeholder::placeholder {
  color: black !important;
}

.card {
  max-width: 100px;
  margin-left: 2rem;
}

.card-body {
  padding: 0;
}

.check-button {
  padding-top: 0.6rem;
  padding-bottom: 0.7rem;
}
</style>
